"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var recoil_1 = require("recoil");
var react_router_dom_1 = require("react-router-dom");
var bubble_arrow_up_16_svg_1 = __importDefault(require("@/assets/svg/bubble-arrow-up-16.svg"));
var logout_16_svg_1 = __importDefault(require("@/assets/svg/logout-16.svg"));
var Styled = __importStar(require("./PopOver.styled"));
var constants_1 = require("@/constants");
var store_1 = require("@/store");
// TODO:(용재) 일반화된 컴포넌트로 리팩토링 해야 함
var PopOver = function (_a) {
    var children = _a.children;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var resetMe = (0, recoil_1.useResetRecoilState)(store_1.$me);
    var _b = __read((0, react_2.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var handleToggleOpen = function (set) {
        setIsOpen(set);
    };
    var handleLogout = function () {
        localStorage.removeItem(constants_1.ACCESS_TOKEN);
        resetMe();
        navigate(constants_1.PATH.LOGIN);
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.PopOverWrapper, __assign({ isOpen: isOpen, onMouseOver: function () { return handleToggleOpen(true); }, onMouseLeave: function () { return handleToggleOpen(false); } }, { children: [children, (0, jsx_runtime_1.jsx)(Styled.BlankArea, {}, void 0), isOpen && ((0, jsx_runtime_1.jsxs)(Styled.Content, { children: [(0, jsx_runtime_1.jsx)(bubble_arrow_up_16_svg_1.default, {}, void 0), (0, jsx_runtime_1.jsxs)(Styled.Select, __assign({ onClick: handleLogout }, { children: [(0, jsx_runtime_1.jsx)(logout_16_svg_1.default, {}, void 0), "\uB85C\uADF8\uC544\uC6C3"] }), void 0)] }, void 0))] }), void 0));
};
exports.default = PopOver;
